import {MuiIcons} from "@leap4/frontend";
import ReportHeader from "../../common/ReportHeader/ReportHeader";
import {urlService} from "../../../routing/urlsService";

const { Tag, GpsFixed: GpsFixedIcon, LocationSearching: LocationSearchingIcon, Toc: TocIcon } = MuiIcons;

export const ReportHeaderWithProps = ({entityName, entityId}:{entityName:string, entityId: string}) => (
    <ReportHeader breadcrumbsIcon={<Tag/>} breadcrumbs={[
        {text: "DataPoints Dashboard", link: urlService.dataPoints(), icon: <TocIcon /> },
        {text: entityName? `${entityName} Details`: "DataPoint Details", link: urlService.editDataPoint(entityId), icon: <LocationSearchingIcon /> },
        {text: entityName || "Loading...", icon: <GpsFixedIcon />},
    ]}/>
)